<template>
  <SnowDataPoint
    :label="label"
    :label-class-names="labelClassNames"
    :left-align="leftAlign"
    :row="row"
    :value-class-names="myValueClassNames"
  >
    <font-awesome-icon
      v-if="!isAllAccess"
      :icon="['fas', 'lock']"
    />
    <span
      v-else
    >
      {{ snowSeasonal }}
    </span>
    <template
      v-if="!label"
      #label
    >
      <span>Season</span>
      <font-awesome-icon
        v-if="isValidTimeIncomplete"
        v-tooltip="vTooltipOptions"
        class="badge-yellow-color"
        icon="exclamation-triangle"
      />
      <font-awesome-icon
        v-else
        v-tooltip="vTooltipOptions"
        :icon="['far', 'info-circle']"
      />
    </template>
  </SnowDataPoint>
</template>

<script>
/* eslint camelcase: off */
import { mapState } from 'pinia';
import {
  dataNotAvailable,
  formatSnow,
  getLastItem,
  isEstimatedSource,
  safeRound,
} from '@@/utils/CommonUtils';
import { useMetaStore } from '@@/stores/Meta';
import { useUserStore } from '@@/stores/User';

export default {
  name: 'SnowSeasonDataPoint',

  props: {
    label: {
      type: String,
      default: null,
    },
    leftAlign: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    row: {
      type: Boolean,
      default: false,
    },
    valueClassNames: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState(useMetaStore, ['dataSourcesById', 'getAttribution']),
    ...mapState(useUserStore, ['isAllAccess']),
    ...mapState(useUserStore, { units: (state) => state.preferences.units }),

    historySnowSeasonal() {
      return getLastItem(this.location.history_snow_seasonal, {});
    },

    isEstimated() {
      return isEstimatedSource(this.historySnowSeasonal.source_id, this.dataSourcesById);
    },

    isValidTimeIncomplete() {
      return this.historySnowSeasonal?.valid_time_incomplete === true;
    },

    labelClassNames() {
      return this.isEstimated && !this.label ? 'estimated-border' : null;
    },

    myValueClassNames() {
      if (!this.isAllAccess) {
        return `all-access-color ${this.valueClassNames}`;
      }

      if (this.snowSeasonal === dataNotAvailable) {
        return `text-light-color ${this.valueClassNames}`;
      }

      return this.valueClassNames;
    },

    snowSeasonal() {
      const { precip_snow } = this.historySnowSeasonal;
      return formatSnow(safeRound(precip_snow), this.units, true);
    },

    vTooltipOptions() {
      if (this.isValidTimeIncomplete) {
        return {
          content: this.historySnowSeasonal.valid_time_incomplete_detail,
          triggers: ['click', 'hover'],
        };
      }

      const attribution = this.getAttribution(
        this.historySnowSeasonal.source_id,
        'history_snow_seasonal',
      );

      if (!attribution) {
        return null;
      }

      return {
        content: attribution.detail,
        triggers: ['click', 'hover'],
      };
    },
  },
};
</script>
